export default {
    delete: 'Delete',
    cancel: 'Cancel'
}
